export default "__VITE_ASSET__DVZNJhSG__"